import FarmList from 'components/modules/FarmList'
import { RowBetween } from 'components/Row'
import { RefreshControl } from 'pages/Liquidity'
import { useMemo } from 'react'
import { AlertTriangle } from 'react-feather'
import styled, { css } from 'styled-components'

export const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.deprecated_text2};
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-wrap: wrap;
    gap: 12px;
    width: 100%;
  `};
`
const Wrapper = styled.div`
  width: 100%;
`

export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 24px 0;
  max-width: 300px;
`

const IconStyle = css`
  width: 40px;
  height: 40px;
  margin-bottom: 0.5rem;
`

export const NetworkIcon = styled(AlertTriangle)`
  ${IconStyle}
`

export default function Farms({ refreshControl }: { refreshControl?: RefreshControl }) {
  const farmListKey = useMemo(() => 'farms-list', [])

  return (
    <Wrapper>
      <FarmList refreshControl={refreshControl} key={farmListKey} />
    </Wrapper>
  )
}
